import React, { useState, useEffect, useContext } from 'react';
import TagChip from './TagChip';
import { Tag } from '../../ViewModels/TagViewModel';
import SearchableSelectModal from '../../Utilities/SearchableSelectModal';
import { MsalContext } from '../../Contexts/MsalContext';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from '@mui/material/styles';

interface ITagsProps {
    systemPK: string,
    setHasTags?: (hasTags: boolean) => void,
}

export default function TagsContainer({ systemPK, setHasTags }: ITagsProps) {
    const { msalFetch } = useContext(MsalContext);
    const [tagsForCall, setTagsForCall] = useState<Tag[]>([]);
    const [tagsForCallLoaded, setTagsForCallLoaded] = useState(false);
    const [tagDropdownList, setTagDropdownList] = useState<string[]>([]);
    const theme = useTheme();

    useEffect(() => {
        fetchData();
    }, []);

    const AddTag = (value) => {
        msalFetch('api/Info/AddTagToCall?systemPK=' + encodeURI(systemPK) + '&tagValue=' + encodeURI(value))
            .then(() => { fetchData() });
    }

    const fetchData = () => {
        setTagsForCallLoaded(false);

        msalFetch('api/Info/GetTagsForCall?systemPk=' + encodeURIComponent(systemPK))
            .then(response => response.json())
            .then(Data => {
                setTagsForCall(Data);
                setTagsForCallLoaded(true);
                if (typeof setHasTags !== "undefined") {
                    setHasTags(Data.length > 0 ? true : false);
                }
            });

        msalFetch('api/Info/GetTagDropdown?systemPk=' + encodeURIComponent(systemPK))
            .then(response => response.json())
            .then(Data => {
                setTagDropdownList(Data);
            });
    }

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        tagsForCallLoaded ?
            <React.Fragment>
                {!isSmallScreen && tagsForCall.map((tag) =>
                    <TagChip key={tag.tagId} label={tag.tagValue} tagID={tag.tagId} systemPK={systemPK} onUpdate={fetchData} />
                )}
                <SearchableSelectModal title={"Add Tag"} onSelect={AddTag} options={tagDropdownList} />
            </React.Fragment>
            :
            <React.Fragment />
    );
}